import React from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { TextField, Link, Box, Typography, Checkbox, FormControlLabel, Paper, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { usePageModel } from "./model";
import { Logo } from "frontend/src/ui/logo";
import { paths } from "frontend/src/pages/paths/index";
import { GuestUserLayout } from "frontend/src/pages/layouts/guest-user-layout";
import { locales } from "frontend/src/domain/localization/i18n";
import { MultilineHelperText } from "frontend/src/ui/multiline-helper-text";
var Copyright = function () { return (React.createElement(Typography, { variant: "body2", align: "center" },
    "© ",
    React.createElement(Link, { color: "inherit", href: "https://imstream.net/" }, "imstream"),
    " ",
    new Date().getFullYear())); };
var useStyles = makeStyles(function (theme) {
    var _a;
    return ({
        root: {
            width: "100%",
        },
        paper: (_a = {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: theme.spacing(4),
                color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
                backgroundColor: theme.palette.type === "dark"
                    ? "rgba(20, 26, 38, 0.34)"
                    : "rgba(255, 255, 255, 0.34)",
                backdropFilter: "blur(28px) saturate(155%)",
                WebkitBackdropFilter: "blur(28px) saturate(155%)",
                border: "1px solid rgba(255, 255, 255, 0.22)",
                borderRadius: 8,
                boxShadow: theme.palette.type === "dark"
                    ? "0 22px 48px rgba(0, 0, 0, 0.24)"
                    : "0 22px 48px rgba(0, 0, 0, 0.16)"
            },
            _a[theme.breakpoints.down("xs")] = {
                padding: theme.spacing(3),
            },
            _a),
        logo: {
            width: "72%",
            maxWidth: 230,
            marginBottom: theme.spacing(2),
            "& path:not([fill])": {
                fill: theme.palette.type === "dark" ? "#fff" : "#111",
            },
        },
        form: {
            width: "100%",
            marginTop: theme.spacing(1.5),
            "& .MuiOutlinedInput-root": {
                color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
                backgroundColor: theme.palette.type === "dark"
                    ? "rgba(255, 255, 255, 0.08)"
                    : "rgba(255, 255, 255, 0.46)",
                "& fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.24)",
                },
                "&:hover fieldset": {
                    borderColor: "rgba(255, 255, 255, 0.46)",
                },
                "&.Mui-focused fieldset": {
                    borderColor: theme.palette.type === "dark" ? "#fff" : "#2f343b",
                },
            },
            "& .MuiInputLabel-root, & .MuiFormHelperText-root": {
                color: theme.palette.type === "dark"
                    ? "rgba(255, 255, 255, 0.72)"
                    : "rgba(47, 52, 59, 0.68)",
            },
            "& .MuiInputLabel-root.Mui-focused": {
                color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
            },
        },
        submit: {
            margin: theme.spacing(3, 0, 2),
            minHeight: 42,
            color: "#fff",
            backgroundColor: "rgba(218, 32, 50, 0.9)",
            boxShadow: "0 12px 24px rgba(218, 32, 50, 0.22)",
            "&:hover": {
                backgroundColor: "#da2032",
            },
        },
        error: {
            color: "red",
        },
        title: {
            fontWeight: 500,
            textShadow: theme.palette.type === "dark"
                ? "0 2px 18px rgba(0, 0, 0, 0.46)"
                : "0 1px 14px rgba(255, 255, 255, 0.55)",
        },
        remember: {
            color: theme.palette.type === "dark" ? "#fff" : "#2f343b",
        },
        links: {
            color: theme.palette.type === "dark"
                ? "rgba(255, 255, 255, 0.86)"
                : "rgba(47, 52, 59, 0.82)",
            "& a": {
                color: "inherit",
            },
        },
    });
});
var Page = function () {
    var _a, _b;
    var classes = useStyles();
    var t = useTranslation(locales.namespaces.guest).t;
    var t2 = useTranslation(locales.namespaces.shared).t;
    var _c = usePageModel(), submit = _c.submit, isSubmitting = _c.isSubmitting, errors = _c.errors, username = _c.username, password = _c.password, rememberMe = _c.rememberMe;
    var onSubmit = function (evt) {
        evt.preventDefault();
        submit();
    };
    var onUserNameChange = function (evt) {
        return username.set(evt.target.value);
    };
    var onPasswordChange = function (evt) {
        return password.set(evt.target.value);
    };
    var onRememberMeChange = function (evt) {
        return rememberMe.set(evt.target.checked);
    };
    return (React.createElement(Box, { className: classes.root },
        React.createElement(Paper, { className: classes.paper },
            React.createElement(Logo, { className: classes.logo }),
            React.createElement(Typography, { component: "h1", variant: "h5", className: classes.title }, t("pages.login.header")),
            React.createElement("form", { className: classes.form, noValidate: true, onSubmit: onSubmit },
                React.createElement(TextField, { variant: "outlined", margin: "dense", required: true, fullWidth: true, id: "login", name: "login", label: t("pages.login.username"), autoFocus: true, autoComplete: "username", disabled: isSubmitting, error: !!errors.username, helperText: React.createElement(MultilineHelperText, { texts: (_a = errors.username) !== null && _a !== void 0 ? _a : [] }), value: username.value, onChange: onUserNameChange }),
                React.createElement(TextField, { variant: "outlined", margin: "dense", required: true, fullWidth: true, label: t("pages.login.password"), type: "password", name: "password", id: "password", autoComplete: "current-password", disabled: isSubmitting, error: !!errors.password, helperText: React.createElement(MultilineHelperText, { texts: (_b = errors.password) !== null && _b !== void 0 ? _b : [] }), value: password.value, onChange: onPasswordChange }),
                React.createElement(Typography, { align: "center", style: { marginTop: 8 } }, t("pages.login.disableVpn")),
                React.createElement(Box, null,
                    React.createElement(FormControlLabel, { className: classes.remember, control: React.createElement(Checkbox, { color: "primary", checked: rememberMe.value, onChange: onRememberMeChange }), label: t("pages.login.rememberMe") })),
                errors.unknown && (React.createElement(Typography, { variant: "caption", className: classes.error }, t2("errors.unknown"))),
                React.createElement(ButtonLoader, { isLoading: isSubmitting, type: "submit", fullWidth: true, variant: "contained", color: "primary", className: classes.submit }, t("pages.login.submit"))),
            React.createElement(Box, { display: "flex", justifyContent: "center", width: "100%", className: classes.links },
                React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "center", width: "100%" },
                    React.createElement(Link, { component: RouterLink, to: paths.password.forgot(), variant: "body2" }, t("pages.login.forgotPassword")),
                    React.createElement(Box, { width: "100%", style: {
                            borderTop: "1px solid rgba(128, 128, 128, 0.25)",
                            marginTop: 18,
                            paddingTop: 14,
                        } },
                        React.createElement(Typography, { align: "center", variant: "body2" },
                            React.createElement(Link, { href: "https://holders.imstream.net", color: "inherit" }, t("pages.login.rightholderLogin"))))))),
        React.createElement(Box, { mt: 4, className: classes.links },
            React.createElement(Typography, { align: "center" },
                React.createElement(Link, { href: "https://x.imstream.net/login" }, t("pages.login.previousVersionLogin"))),
            React.createElement(Copyright, null))));
};
export var LoginPage = function () { return (React.createElement(GuestUserLayout, null,
    React.createElement(Page, null))); };
